/**
 * FERP Portal - Validation List Page (DRR-074: Tabulator DRY Template)
 *
 * CONFIGURE Phase: Data validation rules and constraints.
 * Delegates to TabulatorPrimitiveManager for consistent CRUD across all 25 primitives.
 */

import { TabulatorPrimitiveManager } from '@/components/primitives/TabulatorPrimitiveManager';

export function ValidationListPage() {
  return <TabulatorPrimitiveManager primitiveType="validation" />;
}

export default ValidationListPage;
